import React from "react";
import { Select } from "antd";
import dayjs from "dayjs";

const PRESETS = [
  { label: "Últimos 15 días", value: "15d" },
  { label: "Último mes", value: "1m" },
  { label: "Últimos 3 meses", value: "3m" },
  { label: "Último semestre", value: "6m" },
  { label: "Último año", value: "1y" },
  { label: "─── Año actual ───", value: "__sep__", disabled: true },
  { label: "Primer trimestre (Q1)", value: "q1" },
  { label: "Segundo trimestre (Q2)", value: "q2" },
  { label: "Tercer trimestre (Q3)", value: "q3" },
  { label: "Cuarto trimestre (Q4)", value: "q4" },
  { label: "Primer semestre (H1)", value: "h1" },
  { label: "Segundo semestre (H2)", value: "h2" },
  { label: "Año completo", value: "year" },
];

export function calcularRango(preset) {
  const hoy = dayjs();
  const anio = hoy.year();
  switch (preset) {
    case "15d":  return [hoy.subtract(15, "days"), hoy];
    case "1m":   return [hoy.subtract(1, "month"), hoy];
    case "3m":   return [hoy.subtract(3, "months"), hoy];
    case "6m":   return [hoy.subtract(6, "months"), hoy];
    case "1y":   return [hoy.subtract(1, "year"), hoy];
    case "q1":   return [dayjs(`${anio}-01-01`), dayjs(`${anio}-03-31`)];
    case "q2":   return [dayjs(`${anio}-04-01`), dayjs(`${anio}-06-30`)];
    case "q3":   return [dayjs(`${anio}-07-01`), dayjs(`${anio}-09-30`)];
    case "q4":   return [dayjs(`${anio}-10-01`), dayjs(`${anio}-12-31`)];
    case "h1":   return [dayjs(`${anio}-01-01`), dayjs(`${anio}-06-30`)];
    case "h2":   return [dayjs(`${anio}-07-01`), dayjs(`${anio}-12-31`)];
    case "year": return [dayjs(`${anio}-01-01`), dayjs(`${anio}-12-31`)];
    default:     return null;
  }
}

const PresetRangoFechas = ({ onChange, style }) => {
  const handleChange = (value) => {
    const rango = calcularRango(value);
    if (rango) onChange(rango[0], rango[1]);
  };

  return (
    <Select
      placeholder="Rango rápido"
      style={{ width: 220, ...style }}
      onChange={handleChange}
      allowClear
      options={PRESETS}
    />
  );
};

export default PresetRangoFechas;
